import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import {
  Table,
  Pagination,
  Tooltip,
  Input,
  DatePicker,
  Select,
  Modal,
  PaperClip,
} from 'components';
import {
  CleanIcon,
  ViewIcon,
  Menu as MenuIcons,
  UploadIcon,
  DownloadIcon,
  CommentIcon,
} from 'assets/icons';
import { PreparationService } from 'services';
import moment from 'moment';
import { WhiteImage } from 'assets/img';
import ModalComments from 'components/modal-comments';
import * as Jetemit from 'jetemit';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

class Preparation extends React.Component<Props> {
  timer: any = undefined;

  state = {
    header: ['', '', '', '', ''],
    search: '',
    data: [],
    page: 1,
    last_page: 1,
    item: null,
    visible: false,
    plan_user: undefined,
    // Suscripción al evento 'preparation/reload' que emite App.tsx
    // cuando el abogado acepta desde el modal global.
    unsubscriber: () => {},
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Elaboración Documental',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.setState({
      unsubscriber: Jetemit.on('preparation/reload', () => {
        this.load(true);
      }),
    });

    this.load();
  }

  componentWillUnmount() {
    this.state.unsubscriber();
  }

  load = async (withoutLoading: boolean = false) => {
    const res: any = await PreparationService.get({
      user_id: this.props.user?.id,
      page: this.state.page,
      search: this.state.search,
      withoutLoading,
    });
    this.setState({
      data: res.rows,
      last_page: res.count,
      plan_user: res.plan_user,
    });
  };

  loadComments = async (withoutLoading: boolean = false) => {
    const res: any = await PreparationService.viewComments({
      /* @ts-ignore */
      preparation_id: this.state.item?.id,
      withoutLoading,
    });

    return res;
  };

  openModal = (item: any) => {
    this.setState(
      {
        item,
      },
      () => {
        this.setState({
          visible: true,
        });
      },
    );
  };

  onClose = (reload: boolean = false) => {
    this.setState(
      {
        visible: false,
      },
      () => reload && this.load(),
    );
  };

  getColor = (item: any) => {
    switch (item.status) {
      case Constants.PREPARATION_STATUS.PENDING:
        return Colors.orange;
        break;

      case Constants.PREPARATION_STATUS.FINISHED:
        return Colors.gray3;
        break;
    }
  };

  sendComments = async (item: any) => {
    await PreparationService.sendComments({
      /* @ts-ignore */
      preparation_id: this.state.item?.id,
      user_id: this.props.user?.id,
      message: item.message,
      file: item.file,
      withoutLoading: true,
      hasFile: true,
    });
  };

  finishRevision = async (item: any) => {
    Globals.confirm('¿Desea marcar la revision como finalizada?', async () => {
      try {
        await PreparationService.changeStatus({
          preparation_id: item.id,
          status: Constants.PREPARATION_STATUS.FINISHED,
        });
        Globals.showSuccess('Se ha terminado la revision correctamente');
        this.load(true);
      } catch (error) {}
    });
  };

  render() {
    const { visible } = this.state;
    const plan_user: any = this.state.plan_user;

    return (
      <div id='lawyer-preparation'>
        <Modal
          className='modal-comments'
          visible={visible}
          title='Comentarios'
          onClose={() => this.onClose()}
        >
          {/* @ts-ignore */}
          <ModalComments
            loadComments={(withoutLoading) => this.loadComments(withoutLoading)}
            sendComments={(item) => this.sendComments(item)}
            currentUser={(this.state?.item as any)?.user}
            itemId={(this.state?.item as any)?.id}
            service={Constants.SERVICES.PREPARATION}
            writeComments={
              (this.state?.item as any)?.status != Constants.PREPARATION_STATUS.FINISHED
            }
          />
        </Modal>

        <div className='row row-filter'>
          <div className='col-md-12'>
            <div className='row'>
              <div className='col-md-4'>
                <Input
                  value={this.state.search}
                  name='search'
                  label='Buscar'
                  placeholder='Buscar'
                  className='input-table'
                  onSubmit={() => this.load()}
                  onChange={(e: any) => {
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                      this.load(true);
                    }, 1000);
                    this.setState({
                      search: e.target.value,
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <Table
          title=''
          data={this.state.data.length}
          header={this.state.header}
          headerContent={
            <div className='container-header-table'>
              <div className='container-icon' style={{ backgroundColor: Colors.blue }}>
                <img src={MenuIcons.Menu15} />
              </div>
              <p>Registro de orden de elaboración</p>
            </div>
          }
        >
          {this.state.data.map((i: any, index: number) => {
            return (
              <tr key={index}>
                <td style={{ width: '25%' }}>
                  <div className='container-date'>
                    <div className='date'>
                      <p>{moment(i.created_at).format('DD/MM/YYYY')}</p>
                    </div>
                    <div className='code'>
                      <p>ID {i.number_format}</p>
                    </div>
                  </div>

                  <div className='container-lawyer'>
                    <img
                      src={i.user?.photo ? Constants.BASE_STORAGE + i.user?.photo : WhiteImage}
                    />
                    <div className='container-name'>
                      <p className='bold'>Cliente</p>
                      <p>{i.user?.full_name}</p>
                    </div>
                  </div>
                </td>
                <td>
                  <p className='area-name'>{i.area?.name}</p>
                  <p className='document-name'>{i.document?.name}</p>
                </td>
                <td>
                  <div className='container-status' style={{ backgroundColor: this.getColor(i) }}>
                    <p>{i.status_text}</p>
                  </div>
                </td>
                {i.status === Constants.PREPARATION_STATUS.PENDING ? (
                  <td>
                    <div className='btn-finished' onClick={() => this.finishRevision(i)}>
                      <p>Culminar</p>
                    </div>
                  </td>
                ) : (
                  <td></td>
                )}
                {i.user != null ? (
                  <td className='text-right'>
                    <div className='comments' onClick={() => this.openModal(i)}>
                      <img src={CommentIcon} alt='comentario' />
                      <p>Chatea con cliente</p>
                    </div>
                  </td>
                ) : (
                  <td></td>
                )}
              </tr>
            );
          })}
        </Table>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({
              page: page,
            });
            this.load();
          }}
        />
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(Preparation);
